import { createSlice } from '@reduxjs/toolkit';
import { PaginationMetaModel } from '../../../../shared/components/pagination/model/Pagination.model';
import { ReduxStatus } from '../../../../shared/types';
import {
  getCommunityAdministrators,
  adminCreateCommunityAdmin,
} from './operators';
import { CommunityAdminModel } from '../models/CommunityAdmin.model';
import { resetAll } from '../../../../shared/infra/redux/baseActions';

export interface CommunityAdminState {
  communityAdmins: CommunityAdminModel[];
  pagination: PaginationMetaModel;
  getCommunityAdminStatus: {
    status: ReduxStatus;
    error: string | null;
  };
  createCommunityAdminStatus: {
    status: ReduxStatus;
    error: string | null;
  };
}

const initialState: CommunityAdminState = {
  communityAdmins: [],
  pagination: {
    current: 0,
    pages: 0,
    total: 0,
  },
  createCommunityAdminStatus: {
    status: 'idle',
    error: null,
  },
  getCommunityAdminStatus: {
    status: 'idle',
    error: null,
  },
};

const communityAdminSlice = createSlice({
  name: 'communityAdmin',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCommunityAdministrators.pending, (state) => {
      state.getCommunityAdminStatus = {
        status: 'loading',
        error: null,
      };
    });
    builder.addCase(
      getCommunityAdministrators.fulfilled,
      (state, { payload }) => {
        state.getCommunityAdminStatus = {
          status: 'success',
          error: null,
        };
        state.communityAdmins = payload.model;
        state.pagination = payload.meta;
      },
    );
    builder.addCase(
      getCommunityAdministrators.rejected,
      (state, { payload }) => {
        state.getCommunityAdminStatus = {
          status: 'failure',
          error: payload?.message
            ? payload.message
            : 'Error trying to fetch community administratros',
        };
      },
    );
    builder.addCase(adminCreateCommunityAdmin.pending, (state) => {
      state.createCommunityAdminStatus = {
        status: 'loading',
        error: null,
      };
    });
    builder.addCase(adminCreateCommunityAdmin.fulfilled, (state) => {
      state.createCommunityAdminStatus = {
        status: 'success',
        error: null,
      };
    });
    builder.addCase(
      adminCreateCommunityAdmin.rejected,
      (state, { payload }) => {
        state.createCommunityAdminStatus = {
          status: 'failure',
          error: payload?.message
            ? payload.message
            : 'Error trying to create community admin',
        };
      },
    );
    builder.addCase(resetAll, () => initialState);
  },
});

export default communityAdminSlice.reducer;
